import {useEffect, useRef} from 'react'
import {useLoginStore} from '@store/LoginStore'
import {datadogRum} from '@datadog/browser-rum'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

const DataDogIdentification = () => {
    const userId = useLoginStore(state => state.id)
    const {data: me} = useQueryFetchMe()

    const prevUserInfoRef = useRef<{id?: string; name?: string; email?: string}>({})

    useEffect(() => {
        if (typeof window === 'undefined') return

        // 사용자 정보 객체 생성
        let userInfo: {id?: string; name?: string; email?: string} = {}

        if (userId && userId === me?.id) {
            userInfo.id = userId
            userInfo.name = me.name
            userInfo.email = me.email
            const prevUserInfo = prevUserInfoRef.current
            const isUserInfoChanged =
                prevUserInfo.id !== userInfo.id ||
                prevUserInfo.name !== userInfo.name ||
                prevUserInfo.email !== userInfo.email

            if (isUserInfoChanged) {
                datadogRum.setUser(userInfo)
                prevUserInfoRef.current = userInfo
            }
        } else {
            datadogRum.clearUser()
            prevUserInfoRef.current = {}
        }
    }, [userId, me?.id, me?.name, me?.email])

    return null
}

export default DataDogIdentification
